module.exports = new __parcel__URL__("Solana.47b69164.svg").toString();